import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import { MDBContainer, MDBIcon, MDBCol, MDBRow } from 'mdb-react-ui-kit'
import AgentEandOManager from './../../components/agents/AgentEandOManager/AgentEandOManager.component'
import UserProfileService from './../../shared/services/UserProfile.service'

const EoPolicyPage = props => {
  const isAdmin = UserProfileService.isA(['internal-staff', 'internal-admin', 'agency-owner', 'system-admin'], true),
    contentSlug = isAdmin || UserProfileService.isA(['signature-higher-group']) ? 'signature-agent-eo-details' : false

  return (
    <DashboardLayout>
      <main className='mainSection pb-5'>
        <MDBContainer fluid className='mt-5'>
          <PageHeading label='Agent E&O Policy' url={props?.match?.url} from={props?.location?.state?.from} />
        </MDBContainer>
        <MDBContainer className='pb-5'>
          <MDBRow>
            <MDBCol>
              <div className='content-wrapper'>
                <AgentEandOManager
                  contentSlug={contentSlug}
                  policyTypes={
                    UserProfileService.isA([
                      'affiliate-agent',
                      'affiliate-manager',
                      'associate-agent',
                      'associate-manager',
                    ])
                      ? ['personal']
                      : ['personal', 'company']
                  }
                />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </main>
    </DashboardLayout>
  )
}

export default EoPolicyPage
